import { serverRouteConfig } from "@server/server-route-config"
import { handleShortLinkCreate } from "@server/short-links-api"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/dashboard/short-links/create")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => handleShortLinkCreate(request),
      },
    },
  })
)
